import { defineMessages } from 'react-intl';

export default defineMessages({
  myServices: {
    id: 'dashboard_auto.my_services',
  },
  contactAgent: {
    id: 'dashboard_auto.contact_agent',
  },
  approvedGarages: {
    id: 'dashboard_auto.approved_garages',
  },
  pin: {
    id: 'dashboard_auto.pin',
  },
  declarer_Sinistre: { id: 'dashboard_mrh.que_faire_en_cas_sinistre' },
});
